export default __webpack_public_path__ + "static/media/pexels-photo-6-750x490.3e57bb2b.jpeg";